import { Icon, ListingListItem } from '@requity-homes/component-library';
import React, { useRef } from 'react';
import { FixedSizeList as List } from 'react-window';
import { Listing } from '../../graphql/generated';

interface ScrollableVirtualListProps {
  listings: Listing[];
  repliersCdnUrl: string;
}

const CARD_WIDTH = 330;
const CARD_HEIGHT = 390;

export const ScrollableVirtualList = ({
  listings,
  repliersCdnUrl,
}: ScrollableVirtualListProps) => {
  const listRef = useRef(null);

  const scrollBy = (offset) => {
    const outerRef = listRef.current?._outerRef;
    if (outerRef) {
      outerRef.scrollBy({ left: offset, behavior: 'smooth' });
    }
  };

  return (
    <div className="relative w-full max-w-screen-lg mx-auto p-4 space-y-4">
      {/* Horizontal list */}
      <div className="h-[390px] overflow-hidden relative">
        <List
          ref={listRef}
          height={CARD_HEIGHT}
          width={800}
          layout="horizontal"
          itemCount={listings.length}
          itemSize={CARD_WIDTH}
          outerRef={(ref) => {
            if (ref) {
              // Tailwind smooth scrolling via className
              ref.classList.add('scroll-smooth');
            }
          }}
          style={{ overflowX: 'hidden' }} // make scrollable, but no scrollbar shown unless needed
        >
          {({ index, style }) => {
            const listing = listings[index];
            return (
              <div style={{ ...style }} className="p-2 box-border">
                <ListingListItem
                  className="h-full w-80"
                  key={listing.mlsNumber}
                  repliersCdnUrl={repliersCdnUrl}
                  listing={listing}
                  shouldOpenInNewWindow={true}
                />
              </div>
            );
          }}
        </List>
      </div>
      {/* Navigations */}
      <button
        className="absolute left-0 p-2 bg-gray-800 text-white rounded-full top-1/2"
        onClick={() => scrollBy(-CARD_WIDTH)}
        aria-label="Scroll left"
      >
        <Icon glyph="chevronLeft" className="h-6 w-6" />
      </button>
      <button
        className="absolute right-0 p-2 bg-gray-800 text-white rounded-full top-1/2"
        onClick={() => scrollBy(CARD_WIDTH)}
        aria-label="Scroll right"
      >
        <Icon glyph="chevronRight" className="h-6 w-6" />
      </button>
    </div>
  );
};
